/* Functional, tab-local browsing position. No analytics or form data. */
(() => {
  'use strict';
  if (window.InspireBrowseScroll || window.Shopify?.designMode) return;
  window.InspireBrowseScroll = true;
  const prefix = 'ih-browse-scroll-v1:', property = '__ihBrowseEntry';
  const back = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
  let key, active = false, cancelled = false, leaving = false, timer, expiry, observer, mutation, saveTimer;
  try {
    const state = history.state && typeof history.state === 'object' ? history.state : {};
    key = state[property] || crypto.randomUUID();
    if (!state[property]) history.replaceState({ ...state, [property]: key }, '');
    history.scrollRestoration = 'auto';
  } catch { return; } // Native browser behavior remains available when storage/history is restricted.
  const read = () => { try { return history.state?.__ihBrowsePosition || JSON.parse(sessionStorage.getItem(prefix + key)); } catch { return null; } };
  let saved = read();
  let pending = back && saved?.url === location.href;
  function capture() {
    if (active || pending || leaving) return;
    try {
      const state = history.state && typeof history.state === 'object' ? history.state : {};
      if (!state[property]) history.replaceState({ ...state, [property]: key }, '');
      if (!document.querySelector('main') || (saved?.y > 0 && document.documentElement.scrollHeight < saved.y)) return;
      const sections = [...document.querySelectorAll('main [id^="shopify-section-"]')];
      const cards = [...document.querySelectorAll('main [data-ih-collection-card],main [id^="Slide-"]')].map(e => ({ e, r: e.getBoundingClientRect() })).filter(({ r }) => r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight && r.right > 0 && r.left < innerWidth).sort((a, b) => Math.abs((Math.max(0, a.r.top) + Math.min(innerHeight, a.r.bottom)) / 2 - innerHeight * .35) - Math.abs((Math.max(0, b.r.top) + Math.min(innerHeight, b.r.bottom)) / 2 - innerHeight * .35));
      const anchor = cards[0]?.e || sections.find(e => { const r = e.getBoundingClientRect(); return r.top <= innerHeight * .35 && r.bottom > innerHeight * .35; });
      const selector = anchor?.dataset.productHandle ? '[data-ih-collection-card][data-product-handle="' + CSS.escape(anchor.dataset.productHandle) + '"]' : undefined;
      const rails = [...document.querySelectorAll('main [id^="Slider-"]')].filter(e => e.scrollWidth > e.clientWidth + 2).map(e => ({ id: e.id, x: e.scrollLeft }));
      const record = { url: location.href, x: scrollX, y: scrollY, anchor: anchor?.id, selector, offset: anchor?.getBoundingClientRect().top, rails };
      history.replaceState({ ...history.state, [property]: key, __ihBrowsePosition: record }, '');
      saved = record;
      sessionStorage.setItem(prefix + key, JSON.stringify(record));
      const index = JSON.parse(sessionStorage.getItem(prefix + 'index') || '[]').filter(k => k !== key);
      index.push(key); while (index.length > 40) sessionStorage.removeItem(prefix + index.shift());
      sessionStorage.setItem(prefix + 'index', JSON.stringify(index));
    } catch { /* Navigation never depends on storage availability. */ }
  }
  function stop() {
    active = false; clearTimeout(timer); clearTimeout(expiry); observer?.disconnect(); mutation?.disconnect();
  }
  function restore() {
    if (!active || !saved) return;
    const anchor = saved.selector ? document.querySelector(saved.selector) : saved.anchor && document.getElementById(saved.anchor);
    const y = anchor ? scrollY + anchor.getBoundingClientRect().top - saved.offset : saved.y;
    if (Math.abs(scrollY - y) > 2 || Math.abs(scrollX - saved.x) > 2) scrollTo({ top: Math.max(0, y), left: saved.x, behavior: 'instant' });
    for (const rail of saved.rails || []) {
      const element = document.getElementById(rail.id);
      if (element && Math.abs(element.scrollLeft - rail.x) > 2) element.scrollTo({ left: rail.x, behavior: 'instant' });
    }
  }
  function schedule() { if (active && !timer) timer = setTimeout(() => { timer = null; restore(); }, 40); }
  function begin() {
    if (cancelled || !saved || saved.url !== location.href) return;
    stop(); pending = false; active = true; timer = null;
    const main = document.querySelector('main');
    if (main) { observer = new ResizeObserver(schedule); observer.observe(main); mutation = new MutationObserver(schedule); mutation.observe(main, { childList: true, subtree: true }); }
    restore(); requestAnimationFrame(restore); expiry = setTimeout(stop, 5000);
  }
  // Cancel immediately when the shopper takes control; never pull them back while browsing.
  for (const event of ['wheel', 'touchstart', 'pointerdown', 'keydown']) addEventListener(event, () => { cancelled = true; pending = false; leaving = false; stop(); }, { passive: true, capture: true });
  addEventListener('scroll', () => { if (!active) { clearTimeout(saveTimer); saveTimer = setTimeout(capture, 120); } }, { passive: true });
  document.addEventListener('click', event => {
    const a = event.target.closest('a[href]'); if (!a) return;
    capture();
    if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || a.target === '_blank' || a.hasAttribute('download')) return;
    try { const destination = new URL(a.href, location.href); leaving = destination.origin !== location.origin || destination.pathname !== location.pathname || destination.search !== location.search; } catch {}
  }, { capture: true, passive: true });
  addEventListener('pagehide', () => { capture(); clearTimeout(saveTimer); stop(); cancelled = false; });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') capture(); });
  addEventListener('pageshow', event => { leaving = false; if (event.persisted || back) begin(); });
  document.addEventListener('load', schedule, true);
  if (back) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin, { once: true });
    else begin();
  }
})();
